var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"childnode",staticClass:"outside-click-container",on:{"mouseover":function($event){_vm.overModal=true},"mouseout":function($event){_vm.overModal=false}}},[_vm._t("modal")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }